<template>
    <div>
        <div id="identifier-wrapper" v-if="!ctrl_game.canPlay"
            style="background-image: url('assets/images/Background.jpg')">
            <img width="100px" src="assets/images/magos-media.png" alt="">
            <h4>Please enter your phone number to continue</h4>
            <div class="form__group">
                <input v-model="ctrl_game.playerIdentifier" type="number" class="form__input" id="name"
                    placeholder="Phone Number" required="" />
            </div>
            <div class="button-container">
                <a @click.prevent="ctrl_game.verifyPlayer()" class="blue" href="#">
                    <p><span class="bg blue"></span><span class="base-blue"></span><span class="text">Submit</span></p>
                </a>
            </div>
            <!-- <a @click.prevent="ctrl_game.verifyPlayer()" href="something" class="button2">Submit</a> -->
            <div id="error-text">{{ ctrl_game.errorText }}</div>
        </div>
        <slot v-else></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ctrl_game: this.ctrl_game(),
            }
        },
        mounted() {
            console.log(this.ctrl_game);
        }
    }
</script>